<template lang="pug">
    .main-modal-block.fixed.right-24.bottom-16.z-300( v-if="showNPS")
      
      .mdoal-content-box.block.m-auto.bg-white.shadow-modal.pt-12.pb-20.rounded-12.w-540
        //- div {{currentScore}}
        .flex.justify-end
          span.cursor-pointer.mr-12(@click="close()") 
            iCon.h-24.w-24(iconClass="ico_Close" type="svg")
        .scoresBlock.flex.flex-col.items-center
          .scoreTitle.text-center.text-18p2r.mb-16
            p {{$t('__surveyData.__weValueYourFeedback')}}
            | {{$t('__surveyData.__pleaseLetUsKnowHowWeReDoing')}}
          .flex.mb-12
            .score.w-40.h-40.text-main-0.border.border-main-0.rounded-12.leading-40.cursor-pointer.select-none(v-for="i in scores"  class="hover:shadow-button active:bg-main-deep active:border-main-deep active:text-white"  
            :class="{'mr-4': i < scores, 'bg-main-deep': i == currentScore , 'text-white': i == currentScore , 'border-main-deep' :  i == currentScore }" 
            @click="grade(i)") {{i}}
          .flex.justify-between.text-grey-80.w-432
            div {{$t('__surveyData.__unfavorable')}}
            div {{$t('__surveyData.__favorable')}}
          .mt-16
            Textarea(:placeholder="$t('__surveyData.__letUsKnowHowWeCanHelpYou')" v-model="feedback" :required="false" width="436px" height="96px"  :isDisabled="false"  :maxLength="1000" name="memo" allColor="#00000066")
        .flex.mt-16.justify-center
          Button.w-140( :text="$t('__globeButton.__submit')" type="Send"  @buttonClick='submitSurvey()')




</template>

<script>
// import Button from '@/components/Button.vue';
import { globalFixed } from '@/utils/mixin'
import Checkbox from '@/components/Checkbox.vue';
import Button from '@/components/Button.vue';
import { EMAIL} from '@/enum/global';
import Textarea from '@/components/Textarea.vue';
import { mapMutations} from 'vuex'
import { survey, surveyReset } from "@/api/users.js";
// import { setCookie } from '@/utils/cookies.js';

export default {
  name: 'Nps',
  components: {
    Checkbox,
    Button,
    Textarea
  },
  props: {
  },
  mixins: [globalFixed],
  data() {
    return {
      showNPS: false,
      scores:10,
      currentScore:10,
      improve:[],
      checkOptions: [
        {
          name:  'sdfgh',
          val: 'check0',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check1',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check2',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check3',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check4',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check5',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check6',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check7',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check8',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check9',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check10',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check11',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check12',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check13',
          disabled: false,
        },
        {
          name:  'sdfgh',
          val: 'check14',
          disabled: false,
        }
      ],
      feedback : '',
      showImprove:undefined,

    };
  },
  mounted(){
    this.showImprove = this.currentScore < 7 ? true : false
  },
  methods: {
    ...mapMutations({ //目前用不到，先留著
        setSurveyRequired: 'user/setSurveyRequired',  //要不要跳出來
        setHasSurvey: 'user/setHasSurvey', //有沒有問卷存在
    }),
    grade(i){
      this.currentScore = i
    },
    updateRadio(){

    },
    async close(){
      try{
        const { data } = await surveyReset();
        if(data){
          this.$root.getUserInfo()
        }
      } catch(error){
        this.apiError = error.response.status;
      }
    },
    async submitSurvey(){
      let sendData = {
        score : this.currentScore,
        comment : this.feedback,
      }

      try{
        const { data } = await survey(sendData);
        if(data){
          this.$root.getUserInfo()
        }
        
      } catch(error){
        this.apiError = error.response.status;
      }
      
    },
    contactUs(){
      let email = ''
      if(this.$store.state.user.user['country']){
        email = EMAIL[this.$store.state.user.user['country']]
      }
      console.log('mailto:' + email)
      window.open('mailto:' + email, '_blank');
    },
  },
  watch:{
    'currentScore': function (n){
      this.showImprove = n < 7 ? true : false
    },
    'showImprove': function (n){
      // if(n){
      //   this.$refs.autoHeight.style.maxHeight = '999px'
      // }else{
      //   this.$refs.autoHeight.style.maxHeight = '0'
      // }
    },
    '$store.state.user.user.info.survey_required': function(v) {
      this.showNPS = v;
    },
  }
};
</script>

<style lang="scss" scoped>


.improve{
  transition: all 0.2s ease-in-out;
}

.score{
  &:active{
    box-shadow: none !important;
  }
}


</style>